export default {
  try: 'Try',
  recommendation: 'recommendation',
  noProducts: 'No Products',
};
